(function () {
  if (window.__variantPriceDiffDefined) return;
  window.__variantPriceDiffDefined = true;

  function buildPriceMap(product) {
    var map = {};
    (product.variants || []).forEach(function (variant) {
      (variant.options || []).forEach(function (optVal, idx) {
        if (!map[idx]) map[idx] = {};
        if (map[idx][optVal] === undefined) map[idx][optVal] = variant.price;
      });
    });
    return map;
  }

  function formatMoney(cents) {
    var themeVars = window.themeVariables;
    var fmt = (themeVars && themeVars.settings && themeVars.settings.moneyFormat)
      ? themeVars.settings.moneyFormat
      : 'S/ \x7B\x7Bamount\x7D\x7D';
    var amount     = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var noDecimals = String(Math.round(cents / 100));
    return fmt
      .replace(/\{\{amount_no_decimals_with_comma_separator\}\}/g, noDecimals)
      .replace(/\{\{amount_with_comma_separator\}\}/g, amount)
      .replace(/\{\{amount_no_decimals\}\}/g, noDecimals)
      .replace(/\{\{amount\}\}/g, amount);
  }

  function updatePriceDiffs(picker, selectedVariant, product) {
    var selectedPrice = selectedVariant.price;
    var selectedOptions = selectedVariant.options || [];
    var variants = product.variants || [];
    picker.querySelectorAll('fieldset').forEach(function (fieldset, fieldsetIdx) {
      fieldset.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        var label = fieldset.querySelector('label[for="' + radio.id + '"]');
        if (!label) return;

        var priceLabel = label.querySelector('.block-swatch__variant-price');
        if (!priceLabel) return;

        // Precio de la COMBINACIÓN real: el valor de ESTE swatch en su opción,
        // combinado con las OTRAS opciones tal como están seleccionadas ahora.
        // Así el precio del Kit (abajo) refleja el Lente (arriba) elegido — y
        // viceversa. Antes el mapa guardaba solo el precio de la 1ra variante
        // por valor, por eso el Kit no cambiaba con el Lente.
        var match = variants.find(function (v) {
          var opts = v.options || [];
          if (opts[fieldsetIdx] !== radio.value) return false;
          for (var i = 0; i < selectedOptions.length; i++) {
            if (i === fieldsetIdx) continue;
            if (opts[i] !== selectedOptions[i]) return false;
          }
          return true;
        });
        // Fallback (matriz incompleta): 1ra variante con este valor.
        if (!match) {
          match = variants.find(function (v) {
            return (v.options || [])[fieldsetIdx] === radio.value;
          });
        }
        if (!match) return;

        var price = match.price;
        var diff = price - selectedPrice;

        priceLabel.textContent = formatMoney(price);

        if (diff !== 0) {
          var diffSpan = document.createElement('span');
          diffSpan.className = 'block-swatch__variant-price-diff ' +
            (diff > 0 ? 'block-swatch__variant-price-diff--up'
                      : 'block-swatch__variant-price-diff--down');
          diffSpan.setAttribute('data-price-diff-label', '');
          diffSpan.textContent = ' (' +
            (diff > 0 ? '+' : '-') + formatMoney(Math.abs(diff)) + ')';
          priceLabel.appendChild(diffSpan);
        }
      });
    });
  }

  function handleVariantChange(event) {
    var detail  = event.detail || {};
    var variant = detail.variant;
    var product = detail.product;
    if (!variant || !product) return;
    var formEl = event.target;
    var formId = formEl.getAttribute && formEl.getAttribute('id');
    if (!formId) return;
    var picker = document.querySelector('variant-picker[form="' + formId + '"]');
    if (!picker) return;
    updatePriceDiffs(picker, variant, product);
  }

  document.addEventListener('variant:change', handleVariantChange, true);

  var initializedPickers = new WeakSet();
  function bootstrapPicker(picker) {
    if (!picker || initializedPickers.has(picker)) return;
    initializedPickers.add(picker);

    var formId = picker.getAttribute('form');
    if (!formId) return;

    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      var product = picker.product;
      if (!product && attempts < 50) return;
      clearInterval(interval);
      if (!product) return;

      var formEl = document.getElementById(formId);
      var idInput = formEl ? formEl.querySelector('[name="id"]') : null;
      var selectedVariantId = idInput ? parseInt(idInput.value, 10) : 0;
      var variant = (product.variants || []).find(function (v) { return v.id === selectedVariantId; });
      if (!variant) return;
      updatePriceDiffs(picker, variant, product);
    }, 100);
  }

  function bootstrapAllPickers(root) {
    (root || document).querySelectorAll('variant-picker').forEach(bootstrapPicker);
  }

  document.addEventListener('DOMContentLoaded', function () {
    bootstrapAllPickers();

    if (document.body) {
      var pickerObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.tagName && node.tagName.toLowerCase() === 'variant-picker') {
              bootstrapPicker(node);
            } else if (node.querySelectorAll) {
              node.querySelectorAll('variant-picker').forEach(bootstrapPicker);
            }
          });
        });
      });
      pickerObserver.observe(document.body, { childList: true, subtree: true });
    }
  });
})();
